import Image from "next/image";
import { cn } from "@/lib/utils";
import { optimizeShopifyImage } from "@/lib/community/utils";

interface CommunityImageProps {
  src: string | null | undefined;
  alt: string;
  width?: number;
  height?: number;
  fill?: boolean;
  sizes?: string;
  priority?: boolean;
  className?: string;
  containerClassName?: string;
}

export function CommunityImage({
  src,
  alt,
  width,
  height,
  fill,
  sizes,
  priority,
  className,
  containerClassName,
}: CommunityImageProps) {
  if (!src) {
    return (
      <div
        className={cn(
          "flex items-center justify-center bg-raised text-muted text-sm",
          fill && "absolute inset-0",
          containerClassName,
        )}
      >
        No image
      </div>
    );
  }

  const optimizedSrc = optimizeShopifyImage(src, fill ? 1200 : width ?? 600);

  if (fill) {
    return (
      <div className={cn("relative overflow-hidden", containerClassName)}>
        <Image
          src={optimizedSrc}
          alt={alt}
          fill
          sizes={sizes ?? "(max-width: 768px) 50vw, 25vw"}
          priority={priority}
          className={cn("object-cover", className)}
        />
      </div>
    );
  }

  return (
    <Image
      src={optimizedSrc}
      alt={alt}
      width={width ?? 600}
      height={height ?? 600}
      priority={priority}
      className={cn("object-cover", className)}
    />
  );
}
